import * as React from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Button, Typography } from "@mui/material";
import {
  getTermsAndConditions,
  getTermsAndConditionsDownload,
} from "../../../api/termsConditions";
import { useState } from "react";
import { auth, handleAxiosError } from "../../../config/action-config";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "../../../actions/alert";
import { useNavigate } from "react-router-dom";
import { Box, Container } from "@material-ui/core";
import { useEffect } from "react";

export default function TermsConditionsView() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [check, setCheck] = useState(false);
  useEffect(() => {
    if (user.agreement_status === "verified") {
      navigate("/leads");
    }
    return;
  }, [user.agreement_status]);
  const TermsAndConditionAcceptDecline = async (value) => {
    const patchData = { agreement_status: value };
    try {
      const { data } = await getTermsAndConditions(patchData, user.token);

      dispatch({
        type: auth.UPDATE,
        payload: { agreement_status: data.AgreementStatus },
      });
      dispatch(showAlert(data.msg));
      if (data.AgreementStatus === "accept") {
        navigate("/downloadUploadAgreement");
      } else {
        dispatch(
          showAlert(
            "You have declined the Terms & Conditions.Therefore,you can not access the services."
          )
        );
      }
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  };

  const updateOne = () => setCheck((prev) => !prev);
  const acceptButton = () => {
    if (check === true) {
      TermsAndConditionAcceptDecline("accept");
    } else {
      alert("Please select terms and conditions");
    }
  };
  const declineButton = () => {
    TermsAndConditionAcceptDecline("decline");
  };
  return user.agreement_status === "accept" ? (
    <Typography style={{ margin: 10 }}>
      Terms & Conditions already accepted.
    </Typography>
  ) : user.agreement_status === "decline" ? (
    <Typography style={{ margin: 10 }}>
      You have declined the Terms & Conditions.Therefore,you can not access the
      services.
    </Typography>
  ) : (
    <Container>
      <Box sx={{ margin: "20px", pt: "20px" }}>
        <Typography variant="h6" className="fw-bold">
          Terms & Conditions
        </Typography>
        <br />
        <Typography className="fw-bold">1 . Relationship :</Typography>
        <br />
        <Typography variant="p">
          VE hereby appoints IR, and IR accepts the appointment, to serve as a
          non-exclusive representative of VE to prospective customers
          (“Prospects”) for the promotion of VE Services in accordance with the
          provisions of this Agreement. VE reserves the right to market, promote
          and sell the same or different Services through its employees or any
          other persons or entities. IR is an independent contractor and is not
          an employee of VE. No joint venture or agency is created hereby. IR
          has no authority to act for, or on behalf of VE and is not authorized
          to incur any obligation on behalf of VE or to bind VE in any manner
          whatsoever. IR shall not commit any act, which would in VE’s opinion
          reflect unfavorably upon VE. IR is responsible for all expenses and
          obligations incurred by it because of its efforts to solicit
          Customers.
        </Typography>
        <Typography variant="p">
          Except as set forth herein, in IR's performance of the work, duties
          and obligations devolving upon IR under this Agreement, VE shall
          neither have nor exercise any control or direction over the methods by
          which IR shall perform the work and functions, excepting that IR does
          by this Agreement agree to perform its work and functions at all times
          in accordance with the terms of this Agreement. All applicable
          provisions of law and other rules and regulations of any and all
          governmental authorities relating to licensure and regulation shall be
          complied with by IR.
        </Typography>
        <Typography variant="p">
          IR shall treat all payments received under this Agreement as
          compensation received as an independent contractor, and not as an
          employee. VE is required to and shall not withhold any sums for the
          payment of payroll or other taxes from the sums paid to the IR. IR
          shall pay any and all tax including, but not limited to, federal or
          state income taxes and all federal and state unemployment compensation
          taxes in accordance with applicable law. IR covenants not to take any
          actions or make any representations to the contrary.
        </Typography>
        <br />
        <br />
        <Typography className="fw-bold">
          2 . Independent Reseller’s Responsibilities :
        </Typography>
        <br />
        <ol className="list-style-lower-alpha">
          <li>
            {" "}
            IR must have, at IR’s expense, a phone and fax number and a computer
            with Internet access. The IR shall read all weekly agent updates for
            the purpose of staying abreast of VE's products and services.
          </li>
          <li>
            IR shall submit all documents required by VE for the purpose of
            documenting and processing orders (as set forth below) immediately
            following execution of all orders by a prospective Customer, but in
            any event, not more than three (3) business days after such
            execution.
            <br />
            Except in the event of prior written agreement by VE, such documents
            shall include the following, without limitation:
            <br />
            <ol className="list-style-lower-roman">
              <li> Service agreement executed by the prospective Customer;</li>
              <li> Letter of agency executed by the prospective Customer;</li>
              <li>
                {" "}
                All credit information and / or financial information required
                by VE;
              </li>
              <li>
                {" "}
                Such other forms as may be required from time to time by VE;
              </li>
              <li>
                {" "}
                list of all telephone numbers for which any Services are to be
                provided; and
              </li>
              <li>
                {" "}
                any special instruction relating to the initiation or continued
                use of Services by the prospective Customer or any current
                Customer.
              </li>
            </ol>
          </li>
          <br />
          <li>
            {" "}
            During the Term of this Agreement and continuing for a period of
            twelve (12) months following termination of this Agreement, IR
            agrees not to induce or solicit any Customer originally sold through
            VE to enter into a service agreement with a competitor or supplier
            of a competitor of VE for similar services to those purchased by
            such Customer hereunder, if it will result in the termination of
            VE-provided services during the existing contract term of the
            IR-procured Customer account.
            <br />
            IR hereby agrees that this type of action represents a breach of the
            agent agreement and will be cause for termination without further
            obligations for VE to pay any future commissions, unless upon
            notification of a breach of this type from VE and within 30 days, IR
            cures breach in the sole discretion to the satisfaction of VE. Cures
            that will be acceptable to VE include but are not limited to:
            <br />
            <ol className="list-style-lower-roman">
              <li>
                re-signing customer or Customer in question on a VE service;{" "}
              </li>
              <li>reprimand of IR representative;</li>
              <li>
                {" "}
                cancellation of breaching IRs representative relationship and
                commissions; or
              </li>
              <li>
                receipt by VE of a letter signed by breaching IR representative
                indicating that they are aware that any future solicitation or
                inducement of existing IR/VE accounts will result in termination
                of their relationship with IR.
              </li>
            </ol>
          </li>
        </ol>
        <br />
        <Typography className="fw-bold">3.Territory:</Typography>
        <br />
        <Typography variant="p">
          IR may market the Services within the United States, together with any
          other country in which VE providers are authorized to operate.
        </Typography>
        <br />
        <br />
        <Typography className="fw-bold">4. Services:</Typography>
        <br />
        <Typography variant="p">
          IR may promote and sell the services as published at www.vastedge.com,
          which includes the then-applicable rates, terms, and commission
          structure. VE reserves the right, in its sole discretion, to modify
          the services and/or rates, terms and commissions at any time without
          notice to IR.
        </Typography>
        <br />
        <br />
        <Typography className="fw-bold">5. Payment for Services:</Typography>
        <br />
        <ol className="list-style-lower-alpha">
          <li>
            As compensation, for and in consideration for the services rendered
            by the IR hereunder, VE shall pay the IR commissions as applicable
            schedules agreed upon with customer during contract finalization and
            according to the terms and conditions of this Agreement and the
            attachments hereto. If you elect to receive notification of changes
            (on new sales only) to the commissions posted to the VE website,
            please email partners@VastEdge.com.
          </li>
          <li>
            Commissions shall be calculated based on profits VE receives for the
            customer Services provided by VE from IR-generated sales. Profits
            are defined as: revenues, less all expenses to provide services,
            applicable taxes, assessments, surcharges, or other governmental
            charges identified as separate line items on a Customer's bill
            (collectively "Non-Commission Amounts"). Profits are based on either
            billed or collected revenue (depending on the method used by each VE
            supplier). Each VE commission payment will be postmarked by the 25th
            of each month, provided VE receives timely payment from its vendors.
            To the extent any commissions are calculated and paid to the IR
            based on any Non-Commission Amounts, the IR shall repay the same to
            VE promptly upon receipt of written notice thereof from VE. VE may
            offset any commissions otherwise payable hereunder against any
            Non-Commission Amounts previously paid to IR. VE reserves the right
            to pass through any increase or decrease in commission percentages
            placed into effect by the underlying carrier to the IR without
            penalty upon 30 days' written notice from VE to IR provided,
            however, that the proportion of such carrier's decrease passed
            through to IR shall be no more than IR's proportionate share of the
            total carrier commission rate paid to VE on the affected Services.
            Notwithstanding anything herein to the contrary, the IR is not
            entitled, under any circumstances, to receive any commissions
            hereunder with respect to:
            <br />
            <ol className="list-style-lower-roman">
              <li> any Customer not accepted by VE;</li>
              <li> any Services that are terminated for any reason;</li>
              <li>
                {" "}
                any Services sold in violation of this Agreement or any
                attachments hereto;
              </li>
              <li> IR’s violation of applicable laws, rules or regulations,</li>
              <li>
                {" "}
                if, in VE’s determination, IR-generated Net Revenues are
                insufficient for VE to pay the commissions posted on VE’s
                website, or
              </li>
              <li>
                {" "}
                commissions that result from an unauthorized carrier change.
              </li>
            </ol>
          </li>
          <li>
            {" "}
            Except as otherwise provided in this Agreement, VE's obligation to
            pay commissions shall continue throughout the Term of the Agreement
            and so long thereafter as VE is receiving IR-generated Revenues and
            making profit from any Customer for Services first purchased by
            Customer during the Term of the Agreement. VE's obligation to pay
            commissions shall terminate only in the following circumstances:
            <br />
            <ol className="list-style-lower-roman">
              <li>
                upon the filing for or intention of filing for bankruptcy or
                insolvency of the IR or VE;
              </li>
              <li>
                {" "}
                if the IR breaches any section of this Agreement and fails to
                cure such breach as provided herein; or
              </li>
              <li>
                if the Agreement has terminated and VE is no longer receiving
                IR-generated Net Revenues from any Customer for Services first
                purchased by Customer during the Term of the Agreement. In all
                circumstances, either party will have 30 days to cure any such
                breach and both parties will work in good faith to come to a
                reasonable resolution of any such breach in order to preserve
                this Agreement.
              </li>
            </ol>
          </li>
        </ol>
        <br />
        <Typography className="fw-bold">6. Order Processing:</Typography>
        <br />
        <Typography variant="p">
          VE shall have the right, at its sole discretion, to accept or reject
          all orders and to determine the terms and conditions of the Services
          or other adjustments without liability to IR or any other party (e.g.,
          if VE determines, in its sole judgment, that a new order may be
          fraudulent). VE is not liable to IR for any action by its vendors
          and/or suppliers, regardless of any damages IR may suffer. No Customer
          shall be deemed accepted until VE has executed the applicable service
          agreement and/or any other related or required documents. The IR shall
          have no authority, expressed or implied, to accept any service
          agreements, or other documents, on behalf of VE or otherwise bind VE
          with respect to the provision of any Services or to enter into any
          oral or written orders, contracts, or agreements of any nature on
          behalf of VE or otherwise binding or purporting to bind VE. In
          processing orders pursuant to the foregoing, the IR shall observe lead
          times established by VE from time-to-time, including, without
          limitation, those that may be required due to limited facilities,
          quality considerations, new market focus or emphasis on new Services.
          <br />
          VE's documentation requirements for processing orders may change from
          time-to-time, and the IR shall comply with such VE documentation
          requirements when they are posted on VE’s website. All processing of
          orders and other contracts shall be to the designated VE contact. IR
          shall check the status of its accounts on a regular basis via VE’s
          website, to ensure proper provisioning.
        </Typography>
        <br />
        <br />
        <Typography className="fw-bold">
          7. Product Literature and Marketing Materials:
        </Typography>
        <br />
        <Typography variant="p">
          Any marketing collateral shall be at the sole discretion and burden of
          IR, subject to VE’s prior review and approval upon VE’s request.
          Notwithstanding the foregoing, VE reserves the right, at its sole
          discretion, to provide marketing collateral to IR.
        </Typography>
        <br />
        <br />
        <Typography className="fw-bold">8. Term and Termination.</Typography>
        <br />
        <ol className="list-style-lower-alpha">
          <li>
            The initial term of this Agreement shall be for a period of twelve
            (12) months ("Term") and shall automatically renew for successive
            terms of twelve (12) months until terminated by either party upon
            written notice of not less than thirty (30) days except that either
            party may terminate for cause, if cause exists, in accordance with
            the terms enumerated herein.
          </li>
          <li>
            {" "}
            VE may immediately terminate this Agreement upon written notice and
            without penalty upon the occurrence of any of the following:
            <br />
            <ol className="list-style-lower-roman">
              <li>
                {" "}
                IR solicits any of VE's customers or Customers on behalf of a
                competitor of VE, or IR solicits any VE customer not originally
                sold by IR for the purposes of converting one of the Services to
                another or for selling or upgrading IR's Service;
              </li>
              <li>
                {" "}
                breach of any provision of this Agreement by IR, or if IR
                defaults, fails to perform its obligations hereunder or
                participates or engages in any activity relating to fraud
                against any VE underlying carrier or IR, or if IR falsifies or
                forges any order for Service;
              </li>
              <li>
                {" "}
                IR’s insolvency, bankruptcy, receivership, dissolution or
                cessation of business or its assignment of the agreement without
                IR's prior written consent;
              </li>
              <li>
                {" "}
                IR’s intentional or negligent misrepresentation, or
                disparagement, of the Services or VE;
              </li>
              <li>
                {" "}
                IR’s violation of restricted customer, credit approval, contract
                approval or deposit processes, collections or aging procedures
                or any action outside the scope of the authority granted under
                this Agreement; or
              </li>
              <li>
                {" "}
                IR’s violation of the requirements of this Agreement relating to
                Confidential Information.
              </li>
            </ol>
          </li>
          <li>
            No commission shall be payable following termination of this
            Agreement pursuant to this Section 5 (c).
          </li>
          <li>
            Upon termination of this Agreement, whether for convenience or for
            cause, IR shall:
            <br />
            <ol className="list-style-lower-roman">
              <li>
                immediately cease all marketing, promotion, and solicitation of
                Services to any customer;{" "}
              </li>
              <li>
                {" "}
                return all materials supplied to the IR by VE upon request; and
              </li>
              <li>
                {" "}
                immediately discontinue the use of all trade names, trademarks
                or other materials owned by VE.
              </li>
            </ol>
          </li>
          <li>
            {" "}
            VE may terminate this Agreement for any reason without cause upon
            giving IR thirty (30) days prior written notice of such termination.
          </li>
        </ol>
        <br />
        <Typography className="fw-bold">
          9. Representations, Warranties and Covenants:
        </Typography>
        <br />
        <Typography variant="p">
          IR represents, warrants, and covenants to IR that upon the Effective
          Date and continuing for the term of this Agreement:
          <br />
          <ol className="list-style-lower-alpha">
            <li>
              IR is an entity duly organized and in good standing under the laws
              of its domestic state and/or province, and is qualified to do
              business in the territory and has full and unrestricted power and
              authority to execute and perform under this Agreement.
            </li>
            <li>
              IR has obtained all licenses, permits and other authorizations
              necessary to perform its obligations under this Agreement and
              shall maintain same, as required, in full force and effect during
              the term of this Agreement and shall comply with all orders of
              judicial bodies and all local, state and federal laws.
            </li>
            <li>
              That neither the execution and delivery of this Agreement nor the
              sale of IR’s Services in accordance with the terms of this
              Agreement violates or will violate
              <br />
              <ol className="list-style-lower-roman">
                <li>
                  the provisions or obligations of any other agreement to which
                  IR is a party or by which it is bound, or
                </li>
                <li>
                  IR's articles of incorporation, by-laws or similar corporate
                  governance documents.
                </li>
              </ol>
            </li>
          </ol>
        </Typography>{" "}
        <br />
        <Typography className="fw-bold">10. Indemnification:</Typography>
        <br />
        <Typography variant="p">
          IR shall indemnify, defend and hold VE (and its officers, directors,
          employees, agents and affiliates thereof) harmless from and against
          any and all third-party claims, demands, actions, losses, damages,
          assessments, charges, liabilities, costs and expenses (including
          without limitation, interest, penalties, attorneys' fees and
          disbursements) which may at any time be suffered or incurred by, or be
          asserted against, any and all of them, directly or indirectly, on
          account of or in connection with: a. IR's default under any provision
          herein, breach of any warranty or Representation herein, or failure in
          any way to perform any obligation hereunder; or b. Injury or damage to
          property to any person (including without limitation, any employee of
          either party and any third person), and any damage to or loss of use
          of any property, arising out of or relating to Services or pursuant to
          this Agreement. IR shall further hold VE harmless and indemnify it
          from and against any claim, cause of action, judgment, liability or
          expense relating to or arising out of the acts or omissions of the
          indemnifying party's employees, contractors and agents.
        </Typography>
        <br />
        <br />
        <Typography className="fw-bold">
          11. Limitation of liability and Disclaimer of Warranties:
        </Typography>
        <br />
        <Typography variant="p">
          EXCEPT AS PROVIDED HEREIN, VE SHALL NOT BE LIABLE TO IR, OR ANY THIRD
          PARTY FOR ANY INDIRECT, CONSEQUENTIAL, EXEMPLARY, SPECIAL, INCIDENTAL
          OR PUNITIVE DAMAGES (INCLUDING WITHOUT LIMITATION, LOST BUSINESS,
          REVENUE, PROFITS, OR GOODWILL) ARISING IN CONNECTION WITH THIS
          AGREEMENT OR THE PROVISION OF SERVICES HEREUNDER (INCLUDING ANY
          SERVICE IMPLEMENTATION DELAYS/FAILURES), UNDER ANY THEORY OF TORT,
          CONTRACT, WARRANTY, STRICT LIABILITY OR NEGLIGENCE, EVEN IF IR HAS
          BEEN ADVISED, OR KNEW OR SHOULD HAVE KNOWN OF THE POSSIBILITY OF SUCH
          DAMAGES. VE MAKES NO WARRANTIES, EXPRESS OR IMPLIED, AS TO ANY SERVICE
          PROVISIONED HEREUNDER. IR SPECIFICALLY DISCLAIMS ANY AND ALL IMPLIED
          WARRANTIES, INCLUDING WITHOUT LIMITATION ANY IMPLIED WARRANTIES OF
          MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE. NOTWITHSTANDING
          THE FOREGOING, VE'S TOTAL LIABILITY HEREUNDER SHALL IN NO EVENT EXCEED
          THE LESSER OF:
          <br />
          <ol className="list-style-upper-roman">
            <li>IR'S PROVEN DIRECT DAMAGES; OR</li>
            <li>
              FIVE HUNDRED DOLLARS. THE FOREGOING LIMITATION APPLIES TO ALL
              CAUSES OF ACTIONS AND CLAIMS, INCLUDING WITHOUT LIMITATION, BREACH
              OF CONTRACT, BREACH OF WARRANTY, NEGLIGENCE, STRICT LIABILITY,
              MISREPRESENTATION AND OTHERCLAIMS BASED IN TORT AND/OR CONTRACT.
              IR ACKNOWLEDGES, ACCEPTS AND AGREES TO THE REASONABLENESS OF THE
              PROVISIONS OF THIS INSTANT SECTION AND FURTHER ACKNOWLEDGES THAT
              IR'S AGREEMENT TO THE TERMS SET FORTH HEREIN ARE A MATERIAL
              INDUCEMENT TO VE TO ENTER INTO THIS AGREEMENT.
            </li>
          </ol>
        </Typography>
        <br />
        <br />
        <Typography className="fw-bold">12. Confidentiality:</Typography>
        <br />
        <Typography variant="p">
          All information regarding VE, its operations, policies or services
          obtained in the performance of this Agreement shall be treated as
          Confidential Information in accordance with this Agreement. IR agrees,
          for the Term of this Agreement and continuing for a period of twelve
          (12) months following the termination hereof, that:
          <br />
          <ol className="list-style-lower-alpha">
            <li>
              IR shall ensure that all persons (other than employees of IR)
              coming into possession of confidential information supplied by or
              relating to VE or the business or plan of its actual or potential
              Customers shall not at any time disclose such information to any
              third party or use such information except for the sole purposes
              of this Agreement.
            </li>
            <li>
              IR shall ensure that all employees or agents of IR in any way
              concerned with the work under this Agreement are fully aware that
              they must comply with the obligations relating to secrecy set out
              herein to such an extent as if they were parties hereto and that,
              if requested, they enter into appropriate undertakings with VE
              concerning the same.
            </li>
            <li>
              Without prejudice to IR's other remedies, IR will indemnify VE
              against any breach by IR or any IR employee of the above
              obligations.
            </li>
            <li>
              All business information and materials containing information
              exchanged between the parties, directly or through
              representatives, sub-dealers or employees, including but not
              limited to, identities of customers and Prospects of VE,
              management information reports, details of contracts, operational
              methods, plans or strategies, business acquisition plans, new
              personnel acquisition plans, and any other business affairs of VE
              and any of its affiliates are and shall be treated by IR as
              Confidential Information during the term of this Agreement and at
              all times thereafter. Confidential Information shall not be
              disclosed to any person except officers and employees of the
              receiving party requiring that information or materials to perform
              services pursuant to this Agreement, and shall not be used for the
              benefit of IR except in connection with the performance of its
              duties pursuant to this Agreement. IR shall require all employees,
              officers and agents to whom Confidential Information is disclosed
              to agree, to the same extent as IR has agreed, to maintain the
              confidentiality of the information and materials and not disclose
              such Confidential Information to others. IR shall be liable to VE
              for damages caused by any breach of this provision or by any
              unauthorized disclosure of Confidential Information by its
              officers, employees or agents.
            </li>
            <li>
              The obligations of section shall not apply to any information and
              materials which are
            </li>
            <ol className="list-style-lower-alpha">
              <li>
                available to the public through no breach of this Agreement,
              </li>
              <li>
                required by law or regulation to be disclosed, but only to the
                extent and for the purposes of such required disclosure, or
              </li>
              <li>
                {" "}
                disclosed in response to a valid order of a court or other
                governmental body of the United States with jurisdiction over
                such order, but only to the extent of and for the purposes of
                such order and only if IR first notifies VE of the order within
                a reasonable time so as to allow VE to object or seek an
                appropriate protective order.
              </li>
            </ol>

            <li>
              All subscriber and customer information, which includes, but is
              not limited to, subscriber and customer lists, billing and related
              information, type, nature, location and use of Services, and other
              customer information (collectively referred to as “Customer
              Proprietary Network Information” as that term is defined in
              federal law) is the sole and exclusive property of VE and is to be
              used by IR only during the term of this Agreement. IR is
              responsible for protecting all CPNI of VE Customers to which it
              markets Services under this Agreement in accordance with
              applicable law. If a Customer has elected to restrict usage of its
              CPNI, IR will comply with such restriction(s).
            </li>
            <li>
              This section shall survive the termination or expiration of this
              Agreement.
            </li>
          </ol>
        </Typography>
        <br />
        <br />
        <Typography className="fw-bold">13. Sub-Agents:</Typography>
        <br />
        <Typography variant="p">
          Any commissions due to sub-agents of IR will be paid by VE to the IR.
          VE accepts no responsibility whatsoever in regards to sub-agents or
          employees of the IR. IR will upon request provide VE with the names
          and locations of any sub-agents who are selling VE services that are
          employed or otherwise utilized by the IR. Any sales made by or through
          any sub-agent shall be deemed those of the IR for purposes of this
          Agreement. IR shall maintain a record of all current and prior
          Customers IR has sold through VE, and provide said records to VE upon
          request within 5 business days. IR shall obtain written approval for
          use of any advertisements, solicitations, or marketing tools from VE,
          prior to utilizing such tools. IR shall not in any way misrepresent
          VE, its underlying carriers and vendors, or Services to any customer
          or prospective Customer. IR shall assist in the collection of payments
          owed by a Customer when requested by VE, so long as VE provides the
          required information from the provider in question to the IR, IR may
          escalate customer service issues where carrier trouble ticket
          timeframes have not been met. IR shall pay all costs involved in its
          solicitation and marketing of Services to current or prospective
          Customers.VE will provide the IR with approved marketing materials,
          order forms, and miscellaneous supplies necessary to begin operation,
          and may resupply the IR with such materials as required by the IR from
          time to time.
        </Typography>
        <br />
        <br />
        <Typography className="fw-bold">
          14. Governing Law; Arbitration:
        </Typography>
        <br />
        <Typography variant="p">
          The terms of this Agreement shall be governed by and construed in
          accordance with the laws of the State of California, exclusive of its
          rules respecting choice of law. Any action, suit or other proceeding
          brought by either party hereunder shall be brought and maintained in
          the federal or state courts located within the California and IR
          hereby submits to the personal jurisdiction of those courts. The
          parties waive their right to a jury trial in any civil action brought
          by either party under or arising from this Agreement. The parties
          agree that California has jurisdiction over any disputes or claims
          arising from or relating to this Agreement, and that California is the
          appropriate venue for addressing such claims or disputes. Any disputes
          arising from or relating to this Agreement shall be resolved by
          binding arbitration, which shall be heard within the County of Los
          Angeles, California and governed by the rules of the American
          Arbitration Association. The prevailing party shall be entitled to
          recover its reasonable attorneys' fees, court costs, and such other
          costs related to the enforcement of this Agreement from the other
          party.
        </Typography>
        <br />
        <br />
        <Typography className="fw-bold">15. Insurance:</Typography>
        <br />
        <Typography variant="p">
          IR, at its sole cost and expense, will always procure and keep in full
          force during the term of this Agreement the following insurance:
          <br />
          <ol className="list-style-lower-roman">
            <li>
              A policy of Commercial General Liability Insurance, including
              coverage for premises and operations, personal and advertising
              injury, and contractual liability, to protect the IR and to
              protect VE as an Additional Insured with respect to claims arising
              from IR’s activities, actions and conduct minimum coverage limits
              of $1,000,000 per occurrence and $1,000,000 aggregate must be
              maintained. IR will name VE and its agents, affiliates and
              subsidiaries as an Additional Insured on IR’s General Liability
              policy. Such policy shall provide that coverage is primary to any
              General Liability coverage maintained by VE, its agents,
              affiliates and subsidiaries and that any coverage maintained by VE
              will be non-contributory. IR’s General Liability policy shall
              contain a waiver of subrogation.
            </li>
            <li>
              A policy of Professional Liability or Errors and Omissions
              Insurance, which additionally shall be kept in force for a period
              of two years beyond any termination of this Agreement. Minimum
              coverage limits of $1,000,000 per claim and $1,000,000 aggregate
              must be maintained. The cost of any deductible or self-insured
              retention contained in any of the insurance policies will be borne
              by IR. IR will deliver to VE, prior to commencement of any work,
              evidence of the insurance required. This evidence will be provided
              on the industry standard “ACORD” or comparable certificate form.
              Certificates of insurance must be sent to VE at 1669-2 Hollenbeck
              Ave, #129, Sunnyvale, CA 94087 prior to the IR’s performance of
              any duties under this Agreement. All policies will provide for
              thirty (30) days prior written notice to VE, at the address
              designated by VE, of any renewal or cancellation. The cancellation
              clause on the certificate of insurance will be amended by
              deleting; “endeavor to” and “…but failure to mail such notice will
              impose no obligation or liability of any kind upon the Company.”
              The minimum limits of insurance coverage will in no way limit or
              diminish IR’s liability.
            </li>
          </ol>
        </Typography>
        <br />
        <br />
        <Typography className="fw-bold">16. Miscellaneous:</Typography>
        <br />
        <Typography variant="p">
          This Agreement shall be binding upon and inure to the benefit of the
          parties hereto and their successors and assigns. Failure to enforce
          any rights relating to a party's default hereunder shall not
          constitute a waiver. Provisions of this Agreement identified by the
          context to survive the termination or expiration of this Agreement
          shall so survive. This Agreement constitutes the entire Agreement
          between the parties hereto with respect to the subject matter hereof,
          and it supersedes all prior oral or written agreements, commitments,
          or understandings, with respect to the matters provided for herein.
          This Agreement shall not be amended except by written amendment signed
          by authorized representatives by both parties hereto. IR may not
          assign this Agreement without VE’s prior written consent. No consent
          is necessary for VE to assign this Agreement to any party, including,
          but not limited to, a corporation succeeding to substantially all of
          the assets or business of VE whether by merger, consolidation,
          acquisition or otherwise, or to VE's parent company or other
          affiliate. Paragraph headings in this Agreement are for convenience of
          reference only and shall not affect the interpretation of any of the
          provisions of this Agreement.
        </Typography>
        <br />
        <br />
        <Typography className="fw-bold">17. Notices:</Typography>
        <br />
        <Typography variant="p">
          Notices, requests, and other communications required pursuant to this
          Agreement shall be deemed given if in writing and personally delivered
          or if sent by U.S. mail, postage prepaid, by first class mail, postage
          prepaid, or by overnight delivery and shall be addressed as follows:
          <br />
          To VE: 1669-2 Hollenbeck Ave, #129, Sunnyvale, CA 94087
          <br />
          To IR:
          <br />
          Attention:
        </Typography>
        <br />
        <br />
        <Typography className="fw-bold">
          18. No Contract with Vendors and/or Suppliers:
        </Typography>
        <br />
        <Typography variant="p">
          Nothing in this Agreement shall create a contractual relationship
          between IR and VE's vendors and\or suppliers or make either party a
          third-party beneficiary of any contract, agreement, or policy of any
          other contract.
        </Typography>
        <br />
        <br />
        <Typography className="fw-bold">19. Counterparts:</Typography>
        <br />
        <Typography variant="p">
          This Agreement may be executed in one or more original or facsimile
          counterparts, all of which shall be considered but one and the same
          agreement, and shall become effective when one or more such
          counterparts have been executed by each of the parties and delivered
          to the other parties.
        </Typography>
        <br />
        <br />
        <Typography className="fw-bold">20. Remedies:</Typography>
        <br />
        <Typography variant="p">
          The remedies provided in this Agreement are cumulative and assertion
          by either party of any right or remedy does not preclude the assertion
          by such party of any other rights or the seeking of any other
          remedies.
        </Typography>
        <br />
        <br />
        <Typography className="fw-bold">
          21. Waiver and Failure to Enforce Provisions:
        </Typography>
        <br />
        <Typography variant="p">
          The failure of either party to enforce any of the provisions of this
          Agreement or the waiver thereof in any instance shall not be construed
          as a general waiver or relinquishment on its part of any other
          provisions.
        </Typography>
        <br />
        <br />
        <Typography className="fw-bold">22. Severability:</Typography>
        <br />
        <Typography variant="p">
          If any provision of this Agreement is declared to be invalid, illegal
          or unenforceable, this Agreement shall be revised only to the extent
          necessary to make such provision(s) legal and enforceable or, if,
          impossible, the unaffected portions of this Agreement shall remain in
          full force and effect so long as the Agreement remains consistent with
          the parties’ original intent.
        </Typography>
        <br />
        <br />
        <Typography className="fw-bold">
          23. Complete Agreement of the Parties:
        </Typography>
        <br />
        <Typography variant="p">
          This Agreement is the complete and exclusive statement of agreement
          between the Parties and supersedes all proposals, prior agreements,
          whether written or oral, and all other communications between the
          Parties relating to the subject matter of this Agreement. This
          Agreement cannot be modified unless in written form, signed by both
          Parties.
        </Typography>
        <br />
        <br />
        <FormGroup>
          <FormControlLabel
            control={<Checkbox />}
            onChange={updateOne}
            checked={check}
            label="I have read and agree to the Terms & Conditions"
          />
        </FormGroup>
        <Box sx={{ textAlign: "right" }}>
          <Button
            sx={{ marginRight: 2 }}
            onClick={() => {
              acceptButton();
            }}
            size="small"
            className="green-button"
          >
            Accept
          </Button>

          <Button
            onClick={() => {
              declineButton();
            }}
            size="small"
            className="red-button"
          >
            Decline
          </Button>
        </Box>
      </Box>
    </Container>
  );
}
